function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13z",
  fill: "url(#paint0_linear)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.76 11.19c0-2.215-1.678-3.91-3.614-3.91-1.355 0-2.452.456-3.13 1.467-.678-1.01-1.775-1.467-2.904-1.467-2.194 0-3.872 1.695-3.872 3.91 0-.097 0-.064 0 0 0-.032 0 0 0 0 0 3.292 3.13 6.616 6.776 8.05 2.84-.945 6.744-4.758 6.744-8.05 0 0 0-.032 0 0 0-.064 0-.097 0 0z",
  fill: "url(#paint1_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 13,
  x2: 0.78,
  y2: 23.14,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FCFCFC"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEBEB"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 12.993,
  y1: 7.288,
  x2: 12.993,
  y2: 19.261,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF61AD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF2719"
})));

var SvgSourceApplehealth = function SvgSourceApplehealth(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceApplehealth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_applehealth.aa916cae.svg";
export { ForwardRef as ReactComponent };